import { Document as ReactPDFDocument, Page as ReactPDFPage } from "react-pdf";
import { Spin } from "antd";
import usePdf from "../../Hooks/usePdf";
import DocumentViewer from "../../Components/CommonCommponents/DocumentViewer";
import { getFileType } from "../../Utils/utils";

export default function ResumeView(props) {
  
  const { resume } = props;

  const {
    pdfWrapper,
    initialWidth,
    pdfPagination,
    getPaginationProps,
    onDocumentLoadSuccess: onDocumentLoadSuccessReactPdf,
  } = usePdf();
  const { pageNumber: reactPdfPageNumber } = getPaginationProps;

  const fileType = getFileType(resume);
  return (
    <div className="resume">
      <div className="flex justify-center items-center">
        <div className="w-full">
          <div
            className="pdfWrapper p-3  rounded-[5px] overflow-hidden w-full"
            ref={pdfWrapper}
          >
            <div className="rounded-md overflow-hidden w-full">
              {fileType?.toLowerCase() === "pdf" ? (
                <ReactPDFDocument
                  // file={getResumePath(resume)}
                  file={resume}
                  onLoadSuccess={onDocumentLoadSuccessReactPdf}
                  onLoadError={(error) => {
                    console.log("error", error);
                  }}
                  loading={
                    <div className="pdfLoader bg-white w-full flex items-center justify-center">
                      <Spin />
                    </div>
                  }
                >
                  <ReactPDFPage
                    pageNumber={reactPdfPageNumber}
                    width={initialWidth?.width}
                  />
                </ReactPDFDocument>
              ) : (
                <DocumentViewer fileUrl={resume} fileType={fileType} />
              )}
            </div>
            {fileType?.toLowerCase() === "pdf" && pdfPagination}
          </div>
        </div>
      </div>
    </div>
  );
}
